import React, { FC, useEffect, useState } from 'react';
import { Typography, Grid, Box, Button, Divider } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import useStyles from './styles';
import { AppState } from '../../../store';
import { preferredNetworkAndOTASPAction } from '../../../store/preferred-network-and-otasp/actions';

const PreferredNetworkAndOTASP: FC = () => {
  const selectedEntity = useSelector((state: AppState) => state.search.selectedEntity);
  const otaspStatus = useSelector((state: AppState) => state.search.otaspStatus);
  const classes = useStyles();
  const dispatch = useDispatch();
  const [preferredNetwrokStatus, setPreferredNetwrokStatus] = useState<string>('');

  
  const isCDMAPreferred = selectedEntity?.radioComponents !== null ? selectedEntity?.radioComponents[0]?.CDMAPreferred : false;
  useEffect(() => {
    if (isCDMAPreferred) {
      setPreferredNetwrokStatus('CDMA Preferred')
    } else {
      setPreferredNetwrokStatus('GSM Preferred')
    }
  }, [isCDMAPreferred]);

  const setPreferredNetwork = (input: string) => {
    const parameters = {
      configs: [
        {
          deviceId: selectedEntity?.deviceId,
          deviceType: selectedEntity?.deviceType,
          cellRadioCommand: input
        }
      ],
      wakeup: true,
      wakeupType: 'all',
      reboot: false,
      applicationId: 'iot-gateway',
    }
    const deviceKey = selectedEntity?.deviceKey || '';
    dispatch(preferredNetworkAndOTASPAction(parameters, deviceKey))
  }
  

  return (
    <Grid container direction="row">
      <Grid item xs={12} xl={6}>
        <Typography variant="h6" className={classes.header}>Preferred Network Status: {preferredNetwrokStatus}</Typography>
      </Grid>
      <Grid item xs={12} xl={6}>
          <Grid container>
            <Grid item xs={12} xl={6}>
              <Box px={1} pb={1}>
                <Button
                  id="request-current-software-status"
                  variant="outlined"
                  onClick={() => setPreferredNetwork('REQUEST_PREFERRED_NETWORK_STATUS')}
                >
                  GET PREFERRED NETWORK STATUS
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={12} xl={6}>
              <Box px={1} pb={1}>
                <Button
                  id="set-preferred-as-cdma"
                  variant="outlined"
                  onClick={() => setPreferredNetwork('SET_CDMA_PREFERRED_NETWORK')}
                >
                  SET CDMA PREFERRED
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={12} xl={6}>
              <Box px={1} pb={1}>
                <Button
                  id="set-preferred-as-gsm"
                  variant="outlined"
                  onClick={() => setPreferredNetwork('SET_GSM_PREFERRED_NETWORK')}
                >
                  SET GSM PREFERRED
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Grid>
        <Divider className={classes.divider} />
        <Grid item xs={12} xl={6}>
          <Typography variant="h6" className={classes.otaspHeader}> OTASP</Typography>
        </Grid>
        <Grid item xs={12} xl={12}>
          <Typography variant="h6" className={classes.header}>Status: {otaspStatus || 'N/A'}</Typography>
        </Grid>
        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={12} xl={6}>
              <Box px={1} pb={1}>
                <Button
                  id="activate-otasp-status"
                  variant="outlined"
                  onClick={() => setPreferredNetwork('ACTIVATE_OTASP')}
                >
                  ACTIVATE OTASP REQUEST
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Grid>
    </Grid>
  )
}

export default PreferredNetworkAndOTASP;